module.exports = __webpack_public_path__ + "static/media/nausin.f22b47e3.jpg";